import { Component, OnDestroy, OnInit } from '@angular/core';
import { getFlashState, State as FlashState } from './store/flash.reducer';
import { AppState } from '../../app.state';
import { Store } from '@ngrx/store';
import { DismissFlash } from './store/flash.actions';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'flash',
  template: require('./flash.component.html'),
})
export class FlashComponent implements OnInit, OnDestroy {
  public flashState: FlashState;
  private currentTimeout;
  private destroyed: Subject<boolean> = new Subject();

  constructor(
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.store.select(getFlashState).takeUntil(this.destroyed).subscribe((flashState: FlashState) => {
      this.flashState = flashState;
      if (this.currentTimeout) clearTimeout(this.currentTimeout);

      if (this.flashState.name && this.flashState.expiresAfter) {
        this.currentTimeout = setTimeout(() => {
          this.store.dispatch(new DismissFlash());
        }, this.flashState.expiresAfter);
      }
    });
  }

  ngOnDestroy() {
    this.destroyed.next(true);
  }

  get visible() {
    return this.flashState.name != null;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/flash.component.ts